import * as React from "react";
import Photo from "../model/Photo";

interface PhotoViewerProps {
  photo: Photo;
  onPhotoClicked?: () => void;
}

export default function PhotoViewer({ photo, onPhotoClicked }: PhotoViewerProps) {
  return (
    <div className={"photo-viewer" + (onPhotoClicked ? " clickable" : "")} onClick={onPhotoClicked}>
      <img src={photo.href} alt={"photo"} />
    </div>
  );
}
